import { FormBuilderService } from '../../../../core/services/form-builder.service';
import {
  IDateTimePickerFieldConfig,
  IFormbuilderFieldTypeConfiguration,
} from '../../../../core/models/form-builder-types-configurations.model';
import { fieldsBaseConfigurationFormModel } from './shared.configuration';
import {
  baseFieldParseIntoSettingsFormModel,
  baseFieldUpdateFromSettingsFormModel,
  getDefaultBaseSettingsConfigFormly,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getRequiredValidatorFormConfig,
  getValidationFieldsFormConfig,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-generator.util';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { IFormFieldsValidationModel } from '../../../../core/models/form-fields-formly-validation.model';
import {
  setDateTimePickerValidatorMessageIntoField,
  setRequiredValidatorUpdateFieldFromModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-set-from-model.util';
import { IFormFieldsDisplayModel } from '../../../../core/models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';
import {
  parseDateTimePickerValidatorParseFieldIntoModel,
  parseRequiredValidatorParseFieldIntoModel,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-parse-to-model.util';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { filter, tap } from 'rxjs';

export const defaultDateTimePickerConfigFormModel: IDateTimePickerFieldConfig =
  {
    ...fieldsBaseConfigurationFormModel(),
  };

export const dateTimePickerFieldGetConfiguration = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultDateTimePickerConfigFormModel,
      formlyForm: [
        ...getDefaultBaseSettingsConfigFormly(formBuilderServiceInstance),
        ...generateDateTimePickerForms(),
      ],
    },
    validations: {
      formModel: {},
      formlyForm: [
        getRequiredValidatorFormConfig(),
        getValidationFieldsFormConfig(formBuilderServiceInstance),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};

export const dateTimePickerFieldUpdateFromSettingsFormModel = (
  model: IDateTimePickerFieldConfig,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  const dateTimePickerField = baseFieldUpdateFromSettingsFormModel(
    model,
    field
  );

  if (dateTimePickerField.props) {
    dateTimePickerField.props['allowedDaysOfTheWeek'] =
      model.dateTimePickerSetting?.allowedDaysOfTheWeek?.length === 0
        ? undefined
        : model.dateTimePickerSetting?.allowedDaysOfTheWeek;
    dateTimePickerField.props['dateFormat'] =
      model.dateTimePickerSetting?.dateFormat;
    dateTimePickerField.props['delimeter'] =
      model.dateTimePickerSetting?.delimeter;
    dateTimePickerField.props['startHour'] =
      model.dateTimePickerSetting?.startHour;
    dateTimePickerField.props['endHour'] =
      model?.dateTimePickerSetting?.endHour;
    dateTimePickerField.props['interval'] =
      model.dateTimePickerSetting?.interval;

    dateTimePickerField.props['minDate'] = convertDateStringToObject(
      model?.dateTimePickerSetting?.minDate
    );

    dateTimePickerField.props['maxDate'] = convertDateStringToObject(
      model?.dateTimePickerSetting?.maxDate
    );

    dateTimePickerField.props['addRemoveTimeMinDate'] =
      convertAddRemoveTimeObjectToString(
        model?.dateTimePickerSetting?.addRemoveTimeMinDateSetting
      );

    dateTimePickerField.props['addRemoveTimeMaxDate'] =
      convertAddRemoveTimeObjectToString(
        model?.dateTimePickerSetting?.addRemoveTimeMaxDateSetting
      );
  }

  return dateTimePickerField;
};

export const dateTimePickerFieldParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): IDateTimePickerFieldConfig => {
  const model: IDateTimePickerFieldConfig =
    baseFieldParseIntoSettingsFormModel(field);

  model.dateTimePickerSetting = {
    allowedDaysOfTheWeek: field.props?.['allowedDaysOfTheWeek'],
    dateFormat: field.props?.['dateFormat'],
    delimeter: field.props?.['delimeter'],
    startHour: field.props?.['startHour'],
    endHour: field.props?.['endHour'],
    interval: field.props?.['interval'],
  };

  model.dateTimePickerSetting = {
    ...model.dateTimePickerSetting,
    minDate: convertDateObjectToString(field?.props?.['minDate']),
  };

  model.dateTimePickerSetting = {
    ...model.dateTimePickerSetting,
    maxDate: convertDateObjectToString(field?.props?.['maxDate']),
  };

  model.dateTimePickerSetting = {
    ...model.dateTimePickerSetting,
    addRemoveTimeMinDateSetting: convertAddRemoveTimeStringToObject(
      field?.props?.['addRemoveTimeMinDate']
    ),
  };

  model.dateTimePickerSetting = {
    ...model.dateTimePickerSetting,
    addRemoveTimeMaxDateSetting: convertAddRemoveTimeStringToObject(
      field?.props?.['addRemoveTimeMaxDate']
    ),
  };

  return model;
};

export const dateTimePickerFieldUpdateFromValidationFormModel = (
  model: IFormFieldsValidationModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  field = setRequiredValidatorUpdateFieldFromModel(model, field);
  field = setDateTimePickerValidatorMessageIntoField(model, field);
  return field;
};

export const dateTimePickerFieldParseIntoValidationFormModel = (
  field: FormlyFieldConfig
): IFormFieldsValidationModel => {
  let model: IFormFieldsValidationModel = {};
  model = parseRequiredValidatorParseFieldIntoModel(model, field);
  model = parseDateTimePickerValidatorParseFieldIntoModel(model, field);
  return model;
};

export const dateTimePickerFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, field);
};

export const dateTimePickerFieldParseFieldIntoDisplayFormModel = (
  field: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(field);
};

export const generateDateTimePickerForms = (): FormlyFieldConfig[] => {
  return [
    {
      key: 'dateTimePickerSetting',
      id: 'dateTimePickerSetting',
      type: EIremboFormlyFieldTypes['formly-group'],
      wrappers: ['panel-wrapper'],
      validators: {
        validation: [
          addRemoveTimeValidator,
          minMaxDateValidator,
          startEndHourValidator,
        ],
      },
      props: {
        dragDisabled: false,
        label: 'Date picker settings',
        collapsible: true,
        collapsed: true,
      },
      fieldGroup: [
        {
          key: 'minDate',
          type: EIremboFormlyFieldTypes.customdatepicker,
          props: {
            label: 'Minimum Date',
            placeholder: 'Select minimum date',
          },
        },
        {
          key: 'maxDate',
          type: EIremboFormlyFieldTypes.customdatepicker,
          props: {
            label: 'Maximum Date',
            placeholder: 'Select maximum date',
            required: false,
          },
        },
        {
          key: 'addRemoveTimeMinDateSetting',
          id: 'addRemoveTimeMinDateSetting',
          type: EIremboFormlyFieldTypes['formly-group'],
          wrappers: ['panel-wrapper'],
          props: {
            dragDisabled: false,
            label: 'Mininum current date, add or remove time',
          },
          fieldGroup: [
            {
              key: 'offSet',
              type: 'number',
              props: {
                type: 'number',
                label: 'Time Offset (ex. -2 to remove 2 days)',
                placeholder: 'Provide offset',
                hint: 'This overides minimum date setting',
                change: field => {
                  if (field?.formControl?.value == '0') {
                    field.form?.get('offSetUnit')?.setValue('d');
                  }
                },
              },
              validation: {},
            },
            {
              key: 'offSetUnit',
              type: EIremboFormlyFieldTypes.customdropdown,
              props: {
                label: 'Period',
                placeholder: 'Select period',
                bindLabel: 'description',
                bindValue: 'id',
                multiple: false,
                options: [
                  {
                    id: 'd',
                    description: 'Days',
                  },
                  {
                    id: 'm',
                    description: 'Months',
                  },
                  {
                    id: 'y',
                    description: 'Years',
                  },
                ],
              },
              validation: {
                messages: {
                  required: 'This field is required',
                },
              },
              expressions: {
                'props.required': field => {
                  return field.model?.offSet != null;
                },
              },
            },
          ],
        },
        {
          key: 'addRemoveTimeMaxDateSetting',
          id: 'addRemoveTimeMaxDateSetting',
          type: EIremboFormlyFieldTypes['formly-group'],
          wrappers: ['panel-wrapper'],
          props: {
            dragDisabled: false,
            label: 'Maximum current date, add or remove time',
          },
          fieldGroup: [
            {
              key: 'offSet',
              type: 'number',
              props: {
                label: 'Time Offset (ex. 2 to add 2 days)',
                placeholder: 'Provide offset',
                hint: 'This overides maximum date setting',
                change: field => {
                  if (field?.formControl?.value == '0') {
                    field.form?.get('offSetUnit')?.setValue('d');
                  }
                },
              },
              validation: {},
            },
            {
              key: 'offSetUnit',
              type: EIremboFormlyFieldTypes.customdropdown,
              props: {
                label: 'Period',
                placeholder: 'Select period',
                bindLabel: 'description',
                bindValue: 'id',
                multiple: false,
                options: [
                  {
                    id: 'd',
                    description: 'Days',
                  },
                  {
                    id: 'm',
                    description: 'Months',
                  },
                  {
                    id: 'y',
                    description: 'Years',
                  },
                ],
              },
              validation: {
                messages: {
                  required: 'This field is required',
                },
              },
              expressions: {
                'props.required': field => {
                  return field.model?.offSet != null;
                },
              },
            },
          ],
        },
        {
          key: 'allowedDaysOfTheWeek',
          type: EIremboFormlyFieldTypes.customdropdown,
          props: {
            label: 'Allowed days of the week',
            placeholder: 'Select allowed days of the week',
            bindLabel: 'description',
            bindValue: 'id',
            multiple: true,
            options: [
              {
                id: 1,
                description: 'Monday',
              },
              {
                id: 2,
                description: 'Tuesday',
              },
              {
                id: 3,
                description: 'Wednesday',
              },
              {
                id: 4,
                description: 'Thursday',
              },
              {
                id: 5,
                description: 'Friday',
              },
              {
                id: 6,
                description: 'Saturday',
              },
              {
                id: 7,
                description: 'Sunday',
              },
            ],
          },
          validation: {},
        },
        {
          key: 'dateFormat',
          type: EIremboFormlyFieldTypes.customdropdown,
          props: {
            label: 'Date Format',
            placeholder: 'Select date format',
            bindLabel: 'description',
            bindValue: 'id',
            multiple: false,
            options: [
              {
                id: 'DD MM YYYY',
                description: 'DD MM YYYY',
              },
              {
                id: 'MM DD YYYY',
                description: 'MM DD YYYY',
              },
            ],
          },
          validation: {},
        },
        {
          key: 'delimeter',
          type: EIremboFormlyFieldTypes.customdropdown,
          props: {
            label: 'Delimeter',
            bindLabel: 'description',
            bindValue: 'id',
            options: [
              {
                id: '/',
                description: '/',
              },
              {
                id: '-',
                description: '-',
              },
            ],
            placeholder: 'Provide delimeter',
          },
          validation: {},
        },
        {
          key: 'startHour',
          type: 'number',
          props: {
            label: 'Start hour (24 Hour)',
            placeholder: 'Provide start hour',
            min: 0,
            max: 23,
          },
          validation: {
            messages: {
              min: 'Minimum value is 0',
              max: 'Maximum value is 23',
              required: 'This field is required',
            },
          },
          expressions: {
            'props.required': '!field.hide',
          },
        },
        {
          key: 'endHour',
          type: 'number',
          props: {
            label: 'End Hour (24 Hour)',
            placeholder: 'Provide end hour',
            min: 0,
            max: 23,
            required: true,
          },
          validation: {
            messages: {
              min: 'Minimum value is 0',
              max: 'Maximum value is 23',
              time: 'End hour must be after start hour',
              required: 'This field is required',
            },
          },
          validators: {
            startLessThanEnd: {
              expression: (control: AbstractControl) => {
                const start = control.get('startHour')?.value;
                const end = control.get('endHour')?.value;
                if (start == null || end == null) return true;

                return start <= end;
              },
              message: 'Start hour must be less than or equal to End hour',
            },
          },
        },
        {
          key: 'interval',
          type: 'number',
          props: {
            label: 'Interval',
            placeholder: 'Enter interval',
            min: 0,
            max: 60,
            required: true,
          },
          validation: {
            messages: {
              min: 'Minimum value is 0',
              max: 'Maximum value is 60',
              required: 'This field is required',
            },
          },
          expressions: {
            hide: '!(model?.startHour && model?.endHour)',
            'props.required': '!field.hide',
          },
        },
      ],
      hooks: {
        onInit: field => {
          return field?.options?.fieldChanges?.pipe(
            filter(e => {
              return (
                e.type === 'valueChanges' &&
                (e.field.key === 'offSet' ||
                  e.field.key === 'offSetUnit' ||
                  e.field.key === 'maxDate' ||
                  e.field.key === 'minDate')
              );
            }),
            tap(() => {
              setTimeout(() => {
                field?.fieldGroup
                  ?.find(x => x.key === 'addRemoveTimeMaxDateSetting')
                  ?.fieldGroup?.find(x => x.key === 'offSetUnit')
                  ?.formControl?.updateValueAndValidity();

                field?.fieldGroup
                  ?.find(x => x.key === 'maxDate')
                  ?.formControl?.updateValueAndValidity();
              }, 0);
            })
          );
        },
      },
    },
  ];
};

const getNewDate = (offset: number, period: string) => {
  const date = new Date();

  switch (period) {
    case 'd':
      date.setDate(date.getDate() + offset);
      break;
    case 'm':
      date.setMonth(date.getMonth() + offset);
      break;
    case 'y':
      date.setFullYear(date.getFullYear() + offset);
      break;
    default:
      throw new Error("Invalid period. Use 'd', 'm', or 'y'.");
  }

  return date;
};

const addRemoveTimeValidator = (
  control: AbstractControl,
  _field: FormlyFieldConfig,
  _options: any
): ValidationErrors | null => {
  const formData = control.value;

  const minOffSet = formData.addRemoveTimeMinDateSetting.offSet;
  const minOffSetUnit = formData.addRemoveTimeMinDateSetting.offSetUnit;

  const maxOffSet = formData.addRemoveTimeMaxDateSetting.offSet;
  const maxOffSetUnit = formData.addRemoveTimeMaxDateSetting.offSetUnit;

  if (
    minOffSet == null ||
    minOffSetUnit == null ||
    maxOffSet == null ||
    maxOffSetUnit == null
  ) {
    return null;
  }

  const minDate = getNewDate(minOffSet, minOffSetUnit);
  const maxDate = getNewDate(maxOffSet, maxOffSetUnit);

  if (minDate > maxDate) {
    return {
      addRemoveTime: {
        errorPath: 'addRemoveTimeMaxDate.offSetUnit',
        message: 'Maximum date is must be before minimum date',
      },
    };
  } else {
    return null;
  }
};

const minMaxDateValidator = (
  control: AbstractControl,
  _field: FormlyFieldConfig,
  _options: any
): ValidationErrors | null => {
  const formData = control.value;
  const maxDateData = formData.maxDate;

  const compareControl = formData.minDate;
  if (compareControl == null || maxDateData == null) return null;

  const [maxDay, maxMonth, maxYear] = maxDateData.split('/');
  const [minDay, minMonth, minYear] = compareControl.split('/');

  const maxDate = new Date(`${maxMonth}/${maxDay}/${maxYear}`);
  const minDate = new Date(`${minMonth}/${minDay}/${minYear}`);

  return minDate > maxDate
    ? {
        minmaxdate: {
          errorPath: 'maxDate',
          message: 'Maximum date must be before minimum date',
        },
      }
    : null;
};

const startEndHourValidator = (
  control: AbstractControl,
  _field: FormlyFieldConfig,
  _options: any
): ValidationErrors | null => {
  const formData = control.value;
  const startHour = formData.startHour;

  const endHour = formData.endHour;
  if (endHour == null || startHour == null) return null;

  return startHour > endHour
    ? {
        startendhour: {
          errorPath: 'endHour',
          message: 'End hour must be after start hour',
        },
      }
    : null;
};

const convertDateStringToObject = (dateString: string) => {
  if (!dateString?.trim()) return undefined;
  const value = dateString.split('/');
  const formattedDate = {
    year: Number(value[2]),
    month: Number(value[1]),
    day: Number(value[0]),
  };

  return formattedDate;
};

const convertDateObjectToString = (dateObject: Record<string, unknown>) => {
  if (!dateObject) return undefined;
  return `${dateObject['day']}/${dateObject['month']}/${dateObject['year']}`;
};

const convertAddRemoveTimeStringToObject = (addRemoveTime: string) => {
  if (!addRemoveTime) return undefined;
  const value = addRemoveTime.split(':');
  return {
    offSet: value[0],
    offSetUnit: value[1],
  };
};

const convertAddRemoveTimeObjectToString = (
  addRemoveTime: Record<string, string> | undefined
) => {
  if (!addRemoveTime) return undefined;
  const offSet = addRemoveTime['offSet'];
  const offSetUnit = addRemoveTime['offSetUnit'];
  if (offSet == null || offSetUnit == null) return undefined;
  return `${addRemoveTime['offSet']}:${addRemoveTime['offSetUnit']}`;
};

export const generateDatatimePickerValidationMessages = (
  formBuilderService: FormBuilderService
) => {
  const configuredField: FormlyFieldConfig | null =
    formBuilderService.configureFieldAction$.getValue();

  if (configuredField?.type !== 'customdatetimepicker') return [];

  return [
    {
      key: 'invalidDate',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter invalid date validation error message',
        label: 'Invalid date message:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'minDate',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter minimum date validation error message',
        label: 'Minimum date message:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'maxDate',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter maximum date validation error message',
        label: 'Maximum date message:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'unavailableSlots',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter unavailable slots message validation error message',
        label: 'Unavailable slots message:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'dayOfWeekIsNotAllowed',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter allowed days of the week validation error message',
        label: 'Allowed days of week message:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'dateAndTimeValuesRequired',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter required validation error message',
        label: 'Date and Time required:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'invalidTimeValue',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter invalid time validation error message',
        label: 'Invalid time Message:',
        required: false,
      },
      expressions: {},
    },
    {
      key: 'invalidDateTimeFormat',
      type: EIremboFormlyFieldTypes.input,
      props: {
        placeholder: 'Enter invalid format validation error message',
        label: 'invalid format Message:',
        required: false,
      },
      expressions: {},
    },
  ];
};
